import { buildOnlineServiceAnalyticsEventFile } from './onlineServiceAnalyticsResourceBuilder';

/**
 * onlineService add_to_cart_start for the PDP's main Add to Cart button. Sent on
 * click, before the add resolves, like the listing-card and recommender clicks in
 * listing-click-analytics.js; the confirmed add_to_cart follows from atc-analytics.js.
 *
 * @param {string} sku - the selected variant's SKU
 * @param {number} quantity
 */
export function trackAddToCartStart(sku, quantity) {
    const newEvent = {
        errorMessage: {
            eventName: 'add_to_cart_start',
            eventMessage: '',
            timeStamp: new Date().toISOString(),
        },
    };
    const eventObject = {
        tealium_event: 'add_to_cart_start',
        sku,
        page_type: typeof window.getPageType === 'function' ? window.getPageType() : 'unknown',
        quantity,
    };
    const cartId = typeof window.getCartId === 'function' ? window.getCartId() : null;

    buildOnlineServiceAnalyticsEventFile(newEvent, eventObject, cartId);
}
